export default __webpack_public_path__ + "static/media/off.7d29052d.svg";